import { RegionCount } from "@search/api/types";
import { RegionFacet } from "@search/components/RegionFacet";
import clsx from "clsx";

import { type CommonProps } from "@/types";

import styles from "./RegionFacets.module.css";

const ref = "region-facets";

interface RegionFacetsProps extends Partial<CommonProps> {
  regions: RegionCount;
  update: (id: number) => void;
}

function renderRegions({ regions, update }: RegionFacetsProps) {
  const className = clsx(styles[ref]);

  return Object.entries(regions).map(([id, { name, count, children }]) => (
    <div key={`region_${id}`} className={className}>
      <RegionFacet
        count={Object.keys(children).length > 0 ? null : count}
        id={`region_${id}`}
        label={name}
        onClick={() => update(parseInt(id, 10))}
      />
      {children && renderRegions({ regions: children, update })}
    </div>
  ));
}

function RegionFacets(props: RegionFacetsProps) {
  return renderRegions(props);
}

export default RegionFacets;
export { RegionFacets, type RegionFacetsProps };
